import { hardwareUnitsListPagedOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("hardware-units-paged"),
  endpoint: "hardware-units/list-paged",
  operations: hardwareUnitsListPagedOps,
  listEndpoint: "hardware-units/list",
  roleView: [ROLE.HARDWARE_UNIT_VIEW, ROLE.HARDWARE_UNIT_ADMIN],
  roleAdmin: [ROLE.CONTAINER_ADMIN],
  singularName: (t) => t("Hardware unit"),
  name: (t) => t("Hardware units"),
  initialFilter: {
    status: "all",
  },
  syncCustomerFilter: true,
  dependencies: ["region-code"],
});

export default conf;

/**
 * API doest not support leading zeroes in hardware unit id
 * This formatter redirects the fulltext to the name field
 * @param filter
 */
export function hwUnitPagedMultipleInfiniteFormatter(filter: any) {
  const { fulltext, ...filterRest } = filter;
  return {
    ...filterRest,
    name: fulltext,
  };
}
